import React from 'react'

const ScoreboardTableIcon = ({ className }) => {
  return <div className={`c-icon ${className ? className : ''}`} />
}

export default React.memo(ScoreboardTableIcon)
